var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import OTPInput from 'react-otp-input';
import styles from './styles.module.scss';
export var OtpInput = function (_a) {
    var code = _a.code, setCode = _a.setCode, status = _a.status, onSubmit = _a.onSubmit;
    var handleCodeChange = function (newCode) {
        setCode(newCode);
        if (newCode.length === 6) {
            onSubmit(newCode);
        }
    };
    return (_jsx(OTPInput, { value: code, onChange: handleCodeChange, numInputs: 6, containerStyle: styles.container, renderInput: function (props) {
            var _a;
            return (_jsx("input", __assign({}, props, { type: "number", inputMode: "numeric", className: classnames(styles['c-input-otp'], (_a = {},
                    _a[styles['c-input-otp--error']] = status === 'fail',
                    _a[styles['c-input-otp--success']] = status === 'success',
                    _a[styles['c-input-otp--default']] = props.value !== '',
                    _a)), disabled: status === 'pending' })));
        } }));
};
